export default __webpack_public_path__ + "static/media/pdf.853412ce.svg";